// extracted by mini-css-extract-plugin
export default {"content":"TandC_content__jq5Le","bannerContainer":"TandC_bannerContainer__T--Wj","bannerButton":"TandC_bannerButton__tU77u"};